import { languages } from '../core.js';
import { addJsxTag } from '../utils/jsx-shared.js';
import './javascript.js';

addJsxTag(languages.js, 'jsx');
